module.exports = __webpack_public_path__ + "8366b8e26b7bd32555b638647d18050a.png";